import { render, staticRenderFns } from "./c-widget@.vue?vue&type=template&id=63890120&"
import script from "./c-widget@.vue?vue&type=script&lang=ts&"
export * from "./c-widget@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports